import { AutoCompleteComponent } from './auto-complete/auto-complete.component';

export const Components = [
	AutoCompleteComponent,
];
